import 'twin.macro';
import React, { useState } from 'react';
import Select2 from '@teetsh/app/src/components/Form/Select2';
import {
  FieldMapping,
  Mapping,
} from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import { AddNewField } from '@teetsh/app/src/containers/Eleves/List/components/AddNewField';
import useElevesCustomFields from '@teetsh/app/src/queries/eleves/customFields/useElevesCustomFields';
import { useTranslation } from 'react-i18next';

interface Props {
  mappings: Mapping[] | null;
  value: FieldMapping;
  onChange: (v: FieldMapping) => void;
}

interface EleveField {
  value: FieldMapping;
  label: string;
  sublabel?: string;
}

export function FieldMappingOptions(props: Props) {
  const { value, mappings, onChange } = props;
  const { data: customFields } = useElevesCustomFields();
  const { t } = useTranslation(['common', 'eleve']);
  const [isOpen, setIsOpen] = useState(false);

  const eleveFields: EleveField[] = [
    { value: 'familyName', label: t('eleve:fields.familyName') },
    { value: 'givenName', label: t('eleve:fields.givenName') },
    { value: 'birthday', label: t('eleve:fields.birthday') },
    { value: 'gender', label: t('eleve:fields.gender') },
    { value: 'idbe', label: t('eleve:import.idbe') },
    { value: 'classe', label: t('eleve:import.intituleClasse') },
    { value: 'niveau', label: t('eleve:import.classroomGrade') },
    {
      value: 'ine',
      label: t('eleve:fields.ineShort'),
      sublabel: t('eleve:fields.ineHelperText'),
    },
  ];

  if (isOpen) {
    return (
      <AddNewField
        onClose={() => setIsOpen(false)}
        onAdd={customFieldId => onChange(customFieldId)}
      />
    );
  }
  return (
    <div>
      <Select2
        tw="bg-white"
        options={[
          ...(customFields || []).map(c => ({
            value: c.id,
            label: c.name,
          })),
          ...eleveFields.filter(
            f =>
              !(mappings || [])
                .filter(m => m.mapping !== value)
                .map(m => m.mapping)
                .includes(f.value),
          ),
          {
            value: 'create',
            label: <div>{t('eleve:actions.createNewField')}</div>,
          },
        ]}
        value={value}
        onChange={v => {
          if (v === 'create') {
            setIsOpen(true);
            return;
          }
          onChange(v);
        }}
      />
    </div>
  );
}
